"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var VFProgress = (function () {
    function VFProgress() {
    }
    VFProgress.onDownload = function (complete, progress, total) {
        if (total === void 0) { total = 0; }
        VFProgress.Finished = complete;
        VFProgress.CurrentBytes = progress;
        VFProgress.TotalBytes = total;
        VFProgress.onUpdate();
        if (VFProgress.ProgressCallback) {
            VFProgress.ProgressCallback(complete, progress, total);
        }
    };
    VFProgress.onTextureLoad = function (progress, total) {
        if (total === void 0) { total = 0; }
        VFProgress.CurrentTextures = progress;
        VFProgress.TotalTextures = total;
        VFProgress.onUpdate();
        if (VFProgress.ProgressCallback) {
            VFProgress.ProgressCallback(false, progress, total);
        }
    };
    VFProgress.onReset = function () {
        VFProgress.Finished = false;
        VFProgress.CurrentBytes = 0;
        VFProgress.TotalBytes = 1;
        VFProgress.CurrentTextures = 0;
        VFProgress.TotalTextures = 1;
        VFProgress.onUpdate();
        if (VFProgress.ProgressCallback) {
            VFProgress.ProgressCallback(VFProgress.Finished, VFProgress.CurrentBytes, VFProgress.TotalBytes);
        }
    };
    VFProgress.onComplete = function () {
        VFProgress.Finished = true;
        VFProgress.CurrentTextures = VFProgress.TotalTextures;
        VFProgress.CurrentBytes = VFProgress.TotalBytes;
        VFProgress.onUpdate();
        if (VFProgress.ProgressCallback) {
            VFProgress.ProgressCallback(VFProgress.Finished, VFProgress.CurrentBytes, VFProgress.TotalBytes);
        }
    };
    VFProgress.onUpdate = function () {
        VFProgress.Progress =
            (VFProgress.CurrentBytes / VFProgress.TotalBytes + VFProgress.CurrentTextures / VFProgress.TotalTextures) /
                2;
    };
    return VFProgress;
}());
exports.default = VFProgress;
